module.exports = __webpack_public_path__ + "img/halteknop03.40e6e222.png";